// extracted by mini-css-extract-plugin
export default {"wrap":"PublicLayout_wrap__ezLlV"};